import {pushGTMInternal} from "../../libraries/utils";

const GrantPointsToNonUser = {
	trackPointsGranted: (self, points) => {
		pushGTMInternal(
			"GuestPointsGranted",
			"Pending order page",
			self.$route.path,
			"",
			{
				email: (self.$store.getters.getUserData || {}).email,
				selectedRestaurant: (self.globalSelectedShop || {}).shopName,
				points
			}
		);
	},
	isEnabled: (self) => {
		const isLoggedUser = self.$store.getters.applicationUserLoggedIn;
		const ftValue = self.$store.getters.featureToggles.enableAddPointsToNotLoggedSunsetPointUsers;
		return !isLoggedUser && ftValue;
	},
	shouldTrack: (self, order) => {
		const isEmailValidSunsetPointUser = (((order || {}).orderOptions || {}).grantPoints || {}).isEmailValidSunsetPointUser;
		return GrantPointsToNonUser.isEnabled(self) && isEmailValidSunsetPointUser;
	}
};
export default GrantPointsToNonUser;